module.exports = __webpack_public_path__ + "img/arrow-shop.4786b540.svg";